import { Filter, FilterGroup, FilterParam } from '@types'

const formatParam = (param: FilterParam) =>
  [param.field, param.comparison, param.value]
    .filter(v => v !== undefined && v !== null && v !== '')
    .join(' ')

const formatGroup = (group: FilterGroup) => {
  const parts = group.params.map(formatParam)
  if (!parts.length) return ''
  if (parts.length === 1) return parts[0]
  return `(${parts.join(` ${group.logic} `)})`
}

export const mapChangeCriteria = (criteria: Filter) => {
  const groups = criteria.params
    .map(formatGroup)
    .filter(group => group.length > 0)

  if (!groups.length) return '()'

  const body = groups.length === 1
    ? groups[0]
    : groups.join(`) ${criteria.logic} (`)

  return `(${body})`
}
